export const APP_BRANDING_READY_EVENT = 'h5r:app-branding-ready' as const;
export const APP_BRANDING_FALLBACK_NAME = 'NovelCenter';
export const DOC_BRANDING_GATE_TIMEOUT_MS = 3000;

export type TAppBrandingSource = 'pending' | 'cache' | 'network' | 'fallback';
export type TAppBrandingStatus = 'pending' | 'ready';

export interface IAppBranding {
    appId: number;
    name: string;
    logoUrl: string;
    status: TAppBrandingStatus;
    source: TAppBrandingSource;
}

export const APP_BRANDING_PENDING: IAppBranding = {
    appId: 0,
    name: '',
    logoUrl: '',
    status: 'pending',
    source: 'pending',
};

export function createFallbackAppBranding(appId: number): IAppBranding {
    return {
        appId,
        name: APP_BRANDING_FALLBACK_NAME,
        logoUrl: '',
        status: 'ready',
        source: 'fallback',
    };
}
